import { Component, Injector } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { RestErrorManager } from '../../angular-common/errors/rest-error-manager';
import { FormSettings } from '../forms/form-settings';
import { FormComponent } from '../forms/form.component';
import { Subscription } from 'rxjs';
import { FileTransfer } from '../../angular-common/util';
import { FileDto } from '../base-types';

@Component({
  templateUrl: './file-import-dialog.component.html'
})
export class FileImportDialogComponent extends FormComponent {

  protected _subscription: Subscription = new Subscription()

  upload:FileTransfer;

  showCancel: boolean;
  title: string;
  message: string;
  analyzeService: any;
  analyzeFunctionName: string;
  importService: any;
  importFunctionName: string;
  outcome:string;

  constructor(
    public dialogRef: MatDialogRef<FileImportDialogComponent>,
    protected _injector: Injector) {
      super(_injector)
  }

  async ngOnInit() {
    await super.init()
  }

  /** @override */
  async _manageInputHook() {}

  /** @override */
  protected async _initSettingsHook(): Promise<FormSettings> {
    return {
      fieldsSettings: {
        file: {}
      }
    }
  }

  /** @override */
  protected async _setDatasourceHook(): Promise<{[key: string]: number | string | boolean | (string |number)[] | File | File[]}> {
    return {};
  }

  /** @override */
  protected async _submitHook() {
    console.log('DetailComponent._submitHook()');
  }

  logEnterPressed = () => {
    console.log('ENTER pressed');
  }

  public async analyze() {
    try {
      this._subscription
      .add(
        this._injector.get(this.analyzeService)[this.analyzeFunctionName](this.currentValues.file as File)
        .subscribe(upload => {
          this.upload = upload;
          if (upload.content)
            this.outcome = JSON.parse(upload.content)
        }))
    } catch (error) {
      this._injector.get(RestErrorManager).manageError(error);
    }
  }

  public async import() {
    try {
      this._subscription
      .add(
        this._injector.get(this.importService)[this.importFunctionName](this.currentValues.file as File)
        .subscribe(upload=>{
          this.upload = upload;
          if(upload.content)
            this.outcome = JSON.parse(upload.content)
        }))
    } catch (error) {
      this._injector.get(RestErrorManager).manageError(error);
    }
  }

  ngOnDestroy(): void {
    this._subscription.unsubscribe();
  }
}
